import React from "react";

function Text({ children }: { children: string }) {
  return (
    <div className="rounded-lg whitespace-pre-wrap text-justify">
      <article>{children}</article>
    </div>
  );
}

export default Text;
